import "./PoolOverview.scss"
import { useTheme, useMediaQuery, Box, Link } from "@mui/material"
import RocketIcon from "src/assets/icons/rocket-black.svg"
import React, { ReactElement } from "react"
import useTotalStake from "src/hooks/BoostFarming/useTotalStake"
import CustomCard from "./CustomCard"
import Text from "./Text"
import { CommonWarning } from "./CroWarning"
import AddBoostFactor from "./BoostFarming/AddBoostFactor"
import SelectBoostPool from "./BoostFarming/SelectBoostPool"
import arrowIcon from "../assets/icons/arrow.svg"

export default function BoostOverview(): ReactElement | null {
  const theme = useTheme()
  const isMdDown = useMediaQuery(theme.breakpoints.down("md"))
  const link = "https://docs.ferroprotocol.com/user-guides/pool-boost"
  const totalStake = useTotalStake()
  const isEnabled = totalStake?.gt(0)
  return (
    <CustomCard
      withGradient
      variant="darkest-gray"
      p={0}
      overflow="hidden"
      className="pool-overview-container"
    >
      <Box className="boostOverview">
        <Box className="header" p={2}>
          <Box display="flex" gap={0.5} mt={1} mb="4px" alignItems="center">
            <img src={RocketIcon} height={21} style={{ filter: "invert(1)" }} />
            <Text variant="h4">Pool Boost</Text>
          </Box>
          <Text fontSize="14px">
            By depositing xFER in vault and staking NFT, you can boost the
            current pool APR.{" "}
            <Link color="#fff" target="_blank" href={link}>
              Learn more
            </Link>
          </Text>
        </Box>
        <Box p={2}>
          {isEnabled ? (
            <Box
              display="flex"
              alignItems="center"
              gap={2}
              flexDirection={isMdDown ? "column" : "row"}
            >
              <AddBoostFactor />
              <img
                src={arrowIcon}
                width="16px"
                height="16px"
                style={isMdDown ? { transform: "rotate(90deg)" } : {}}
              />
              <SelectBoostPool />
            </Box>
          ) : (
            <CommonWarning content="(1) Add liquidity to any of the pool and (2) stake LP tokens before enjoying pool boosting." />
          )}
        </Box>
      </Box>
    </CustomCard>
  )
}
